import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadNucleoDto, CreateNucleoDto, UpdateNucleoDto } from '@/api.types';

export async function GetNucleos(skip: number, take: number, comarca: number = 0, nome: string | undefined = undefined) {
  let where = '0=0';

  if (comarca && comarca > 0) where = where + ' and comarca.id = ' + comarca;

  if (nome) where = where += ` and nucleo.nome ilike '%${nome}%'`;

  return api
    .get(Endpoints.NUCLEO, { params: { skip: skip, take: take, where: where } })
    .then((response) => {
      return GetApiReturn<ReadNucleoDto>(response.data as Array<ReadNucleoDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ReadNucleoDto>(error, 'Falha ao listar nucleos.');
      return GetApiReturnError<ReadNucleoDto>();
    });
}

export async function GetNucleo(id: number) {
  return api
    .get<ReadNucleoDto>(Endpoints.NUCLEO + '/' + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadNucleoDto>(error, 'Falha ao bucar o nucleo.' + id);
    });
}

export async function SetNucleo(nucleo: CreateNucleoDto | UpdateNucleoDto) {
  if (nucleo.id !== null && nucleo.id != undefined && nucleo.id > 0) {
    return api
      .put(Endpoints.NUCLEO + '/' + nucleo.id, nucleo as UpdateNucleoDto)
      .then(() => {
        return 'Nucleo atualizada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao atualizar o nucleo.',
        );
      });
  } else {
    return api
      .post(Endpoints.NUCLEO, nucleo as CreateNucleoDto)
      .then(() => {
        return 'Nucleo cadastrada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao cadastrar o nucleo.',
        );
      });
  }
}

export async function UpdateNucleoMaxEstagiarios(
  idNucleo: number,
  maxEstagiarios: number,
) {
  const obj = {
    id: idNucleo,
    maximoIntegrantes: maxEstagiarios,
  };
  return api
    .patch(Endpoints.NUCLEO + '/maxestagiarios', obj)
    .then(() => {
      return 'Nucleo atualizada.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao atualizar o nucleo.');
    });
}

export async function DeleteNucleo(id: number) {
  return api
    .delete(Endpoints.NUCLEO + '/' + id)
    .then(() => {
      return 'Nucleo removida.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover nucleo.');
    });
}

export async function GetTitularidades() {
  return api
    .get<ReadNucleoDto[]>(Endpoints.NUCLEO + '/titularidades')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadNucleoDto[]>(error, 'Falha ao buscar o objetos.');
    });
}
